import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import QuillEditor from "../../../elements/blog/QuillEditor.jsx";
import { useDelData, useUpdateData, useGetData, useGetUserId } from "../../../hooks/useApi.jsx";
import BreadcrumbGray from "../../../elements/common/BreadcrumbGray.jsx";
import Breadcrumb from "../../../elements/common/Breadcrumb.jsx";

function GalleryUpdate() {
  const location = useLocation();

  const boardId = location.pathname.slice(location.pathname.lastIndexOf("/") + 1);
  const [userId, isAdmin, writer] = useGetUserId();
  const [title, content, setContent, setTitle, data] = useGetData("/board/gallery-posts", boardId);
  const [contents, setContents, delContent] = useDelData("/board/gallery-posts", boardId, "/gallery");
  const updateData = useUpdateData("/board/gallery-posts", boardId, "/gallery");

  const handleForm = async (e) => {
    e.preventDefault();
    const info = {
      user: parseInt(userId),
      title: title,
      content: content,
    };
    const processedContent = content.replace(/<p>/g, "").replace(/<\/p>/g, "").trim();
    if (content === "<p><br></p>" || processedContent === "") {
      window.alert("내용을 입력해주세요.");
      return;
    }
    await updateData(info);
  };

  const handleText = (value) => {
    setContent(value);
  };

  return (
    <>
      <Breadcrumb title="작품갤러리" />
      <div className="boardInsert pt--50 pb--120">
        <div className="boardInsert-wrap">
          <form method="post" onSubmit={handleForm}>
            <table className="boarderInsertTable">
              <thead>
                <tr>
                  <td>
                    <strong>제목</strong>
                  </td>
                  <td>
                    <input type="text" name="title" value={title} placeholder="제목을 입력해주세요" onChange={(e) => setTitle(e.target.value)} />
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>작성자</strong>
                  </td>
                  <td>
                    <strong style={{ marginLeft: 10 }}>{writer}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>내용</strong>
                  </td>
                  <td className="QnaBoardcontent">
                    {/* <EditorToolbar/> */}
                    <QuillEditor value={content} onChange={handleText} />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="QNABoardBtnGrp">
              <button type="submit">저장</button>
              <button type="button" className="del" onClick={delContent}>
                삭제
              </button>
              <Link to="/board">
                <button type="button" className="list">
                  목록
                </button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default GalleryUpdate;
